import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { styled } from "@mui/material/styles";
import { useTheme } from "@mui/material/styles";
import { setError } from "../reducers/appSlice";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import InputLabel from "@mui/material/InputLabel";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableFooter from "@mui/material/TableFooter";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';

import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined";
import ClearIcon from "@mui/icons-material/Clear";
import DoneOutlineRounded from "@mui/icons-material/DoneOutlineRounded";
import Modal from "../components/Modal";
import ToggleButton from "@mui/material/ToggleButton";

import api from "../service/api";

const TableCellHead = styled(TableCell)(({ theme }) => ({
  color: "#3c4b64",
  padding: theme.spacing(1, 0, 1),
}));

const headCells = [
  {
    id: "expediente",
    numeric: true,
    disablePadding: true,
    label: "Expediente",
    align: "center",
    width: 200,
  },
  {
    id: "tramiteInterno",
    numeric: true,
    disablePadding: false,
    label: "Trámite Interno",
    align: "center",
    width: 200,
  },
  {
    id: "asunto",
    numeric: false,
    disablePadding: false,
    label: "Asunto",
    align: "left",
    width: 600,
  },
  {
    id: "folios",
    numeric: false,
    disablePadding: false,
    label: "Folios",
    align: "center",
    width: 100,
  },    
];

function EnhancedTableHead(props) {
  
  return (
    <TableHead>
      <TableRow>        
        {headCells.map((headCell) => (
          <TableCellHead
            key={headCell.id}
            align= {headCell.align}
            padding="normal"            
            width={headCell.width}
          >
            <b>{headCell.label}</b>            
          </TableCellHead>          
        ))}        
        <TableCellHead width={200} align="center">
          <b>Acciones</b>
        </TableCellHead>
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const TablePaginationActions = (props) => {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
};

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const Recepcionar = (props) => {
  const [open, setOpen] = React.useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [selected, setSelected] = React.useState([]);

  const [page, setPage] = React.useState(0);
  const [datos, setDatos] = useState(props.datos);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const [resultado, setResultado] = useState("");
  const [openResultado, setOpenResultado] = React.useState(false);
  
  const dispatch = useDispatch();
  
  useEffect(() => {
    setDatos(props.datos);
  }, [props.datos]);
  
  const handleOpen = () => {
    setOpen(true);
    setDatos(props.datos);
    setSubmitting(false);
  };

  const handleClose = () => {
    setOpen(false);    
  };

  const handleCloseResultado = () => {
    setOpenResultado(false);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = datos.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };
  
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - datos.length) : 0;

  const verResultado = (resultado) => {
    setResultado(resultado);
    setOpenResultado(true);
  };

  const accionConfirmarRecepcion = () =>{
    let tramites_id = "";
      for (let index = 0; index < datos.length; index++) {
        const elemento = datos[index];
        if (index === 0) {
          tramites_id= elemento.id;
        } else {
          tramites_id= tramites_id +","+ elemento.id;
        }
      }

    api
      .recepcionarMovimiento({
        TRA_ID: tramites_id,
      })
      .then((res) => {  
        console.log("res: "+res.data);      
        verResultado(res.data);
      })
      .catch((e) => {
        console.log("error: "+e.response.data.detalle);
        dispatch(setError(e.response.data.error));
      })
      .finally(() => {
        props.resultado();        
        handleClose();        
      });
    
  }

  const quitar = (index) => {
    let nuevo = [...datos];
    nuevo.splice(index, 1);
    setDatos([...nuevo]);
  };

  return (
    <Grid color="primary">
      {props.mostrar === "boton" ? (
        <Button variant="gris" onClick={handleOpen} sx={{m: 1}}>
          Recepcionar
        </Button>
      ) : (
        <ToggleButton
          value="recepcionar"
          title="Recepcionar"
          disabled={props.numSelected === 0 || props.submitting}
          onClick={handleOpen}
          sx={{border:0, "&.Mui-disabled": {border: 0,}}}
        >
          <PlaylistAddCheckOutlinedIcon />        
        </ToggleButton>
      )}

      <Modal
        open={open}
        handleClose={handleClose}        
        size="lg"
      >
        <form
          id="recepcionar"
          name="recepcionar"
          noValidate
          autoComplete="off"
        >
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} sx={{ marginBottom: 1}}>
              <Typography variant="titulo">REGISTRAR RECEPCIÓN</Typography>
            </Grid>
            <Grid item xs={12} sm={12}>
              <TableContainer>
                <Table
                  sx={{ minWidth: 750, border: "1px solid #dee2e6" }}
                  aria-labelledby="tableTitle"
                  size="small"
                >
                  <EnhancedTableHead
                    numSelected={selected.length}
                    onSelectAllClick={handleSelectAllClick}
                    rowCount={datos.length}
                  />
                  <TableBody>                    
                    {
                      datos.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((dato, index) => {
                        const isItemSelected = isSelected(dato.id);
                        const labelId = `enhanced-table-checkbox-${index}`;
                        
                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            aria-checked={isItemSelected}
                            tabIndex={-1}
                            key={dato.id}
                            selected={isItemSelected}
                            sx={
                              index % 2 === 0
                                ? { backgroundColor: "#f2f2f2" }
                                : { backgroundColor: "#fff" }
                            }
                          >
                            <TableCell 
                              color="primary"
                              inputprops={{
                                "aria-labelledby": labelId,
                              }}
                              component="th"
                              id={labelId}
                              scope="row"
                              padding="none"
                            >
                              {dato.expedienteConFecha}
                            </TableCell>
                            <TableCell align="left">
                              {dato.fechaTramiteInterno !== "" && dato.fechaExpediente !== "" && dato.fechaTramiteInterno !== dato.fechaExpediente ? dato.tramiteInternoConFecha : null}
                            </TableCell>
                            <TableCell align="left" sx={{ pl: 0, maxWidth: 600, whiteSpace: "nowrap", overflow: "hidden",textOverflow: 'ellipsis'}}>{dato.asunto}</TableCell>    
                            <TableCell align="right">
                              <InputLabel id="datoFolios" sx={{mr: 2}}>
                                {dato.folios}
                              </InputLabel>
                            </TableCell>
                            <TableCell align="center">
                              <IconButton
                                title="Quitar de la lista"
                                size="small"
                                onClick={() => quitar(index)}
                              >                                  
                                <RemoveCircleOutlineOutlinedIcon />
                              </IconButton>
                            </TableCell>                          
                          </TableRow>
                        );
                      })}
                    {datos.length === 0 && !submitting ? (
                      <TableRow>
                      <TableCell colSpan="8" align="center">
                        <Typography variant="aclaracion">No hay ningún trámite para recepcionar</Typography>
                      </TableCell>
                    </TableRow>
                    ) : (
                      null
                    )}
                    {emptyRows > 0 && (
                      <TableRow
                        style={{
                          height: 53 * emptyRows,
                        }}
                      >
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>
                  <TableFooter>
                    <TableRow>
                      <TablePagination
                        rowsPerPageOptions={[
                          5,
                          10,
                          25,
                          { label: "Todos", value: datos.length },
                        ]}
                        count={datos.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        selected={selected}
                        ActionsComponent={TablePaginationActions}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            </Grid>

            {/* Botones */}
            <Grid
              item
              xs={12}
              align="right"
              sx={{ display: { xs: "none", md: "inline" } }}
            >
              <Button
                variant="plata"
                onClick={handleClose}
                endIcon={<ClearIcon />}
                sx={{ m: 1 }}
              >
                {"Cancelar"}
              </Button>{" "}
              <Button
                sx={{ m: 1 }}
                variant="verde"
                color="primary"
                onClick={accionConfirmarRecepcion}
                disabled={datos.length === 0 || submitting}
                endIcon={<DoneOutlineRounded />}                
              >
                {submitting ? "Confirmando..." : "Confirmar"}
              </Button>
            </Grid>
            <Grid
              item
              xs={12}
              align="right"
              sx={{ display: { xs: "block", md: "none" } }}
            >
              <IconButton color="primary" onClick={handleClose} title="Cancelar">
                <ClearIcon />
              </IconButton>{" "}
              <IconButton
                color="primary"
                onClick={accionConfirmarRecepcion}
                disabled={datos.length === 0 || submitting}
                title="Confirmar"
              >
                <DoneOutlineRounded />
              </IconButton>
            </Grid>

            <Grid item xs={12} sm={12}>
              {" "}
            </Grid>
          </Grid>
        </form>
      </Modal>

      <Modal
        open={openResultado}
        handleClose={handleCloseResultado}
        size="sm"
      >
        {resultado.split("\n").map((i, key) => {          
          return <Typography  variant="cuerpo" paragraph key={key}>{i}</Typography>;
        })}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
          }}
        >
          <Button
            sx={{ m: 1 }}
            variant="plata"
            onClick={handleCloseResultado}
            endIcon={<ClearIcon />}
          >
            {"Cerrar"}
          </Button>
        </Box>
      </Modal>
    </Grid>
  );
};

export default Recepcionar;